/* eslint-disable react/jsx-props-no-spreading */
import { memo, ReactElement, ReactNode } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  DialogProps,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';

type EnhancedDialogProps = DialogProps & {
  children: ReactElement
  dialogTitle: string
  dialogContent: ReactNode
  dialogActions?: ReactElement
  className?: string
};

const EnhancedDialog: React.FC<EnhancedDialogProps> = (props) => {
  const { children, dialogTitle, dialogContent, dialogActions, className, ...restProps } = props;
  if (children === undefined || children === null) return null;

  const dialogTitleAction = (
    <DialogTrigger action="close">
      <Button
        appearance="subtle"
        data-testid="close-dialog-button"
        aria-label="close"
        icon={<Dismiss20Regular />}
      />
    </DialogTrigger>
  );

  return (
    <Dialog modalType="alert" {...restProps}>
      <DialogTrigger disableButtonEnhancement>{children}</DialogTrigger>

      <DialogSurface className={className}>
        <DialogBody>
          <DialogTitle action={dialogTitleAction}>{dialogTitle}</DialogTitle>

          <DialogContent>{dialogContent}</DialogContent>

          <DialogActions>{dialogActions}</DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default memo(EnhancedDialog);
